// ABOUTME: Reads a node's commercial name the way the server's catalog does — by content type only.
// ABOUTME: Keeps the tenant-configured `modelName` field the single source of truth for the label.

/** The `prototype.contentTypes.modelName` setting, as the settings query returns it. */
export interface ModelNameSetting {
    contentTypeGroup?: string | null;
    contentType?: string | null;
}

/** Minimal shape of a node content entry; the group is deliberately not part of it. */
export interface NameContent {
    contentType: string;
    value?: ReadonlyArray<{ value?: ReadonlyArray<unknown> | null } | null> | null;
}

/**
 * The content type holding a model's commercial name. The fallback to `name` matches the default
 * `initializePrototype` writes, so tenants that predate the setting keep working — but a tenant
 * that configures another field (Interroll stores it in `commercial_name`) must win over it, which
 * only happens if the settings query actually selects `modelName`.
 */
export function resolveModelNameField(setting?: ModelNameSetting | null): string {
    return setting?.contentType || 'name';
}

/**
 * The node's name, matched on the content type alone. The model-selection catalog resolves it the
 * same way (`getLocalizedValue`), so a line item and its catalog card cannot disagree because the
 * value sits in an unexpected content type group.
 */
export function readNodeName(
    contents: ReadonlyArray<NameContent> | null | undefined,
    nameField: string,
): string {
    const raw = contents?.find(c => c.contentType === nameField)?.value?.[0]?.value?.[0];
    return typeof raw === 'string' ? raw : '';
}
